import React, { ComponentType } from 'react';
import { PriorityScrollableContentProvider } from '..';

function withPriorityScrollableContentProvider<P extends object>(
  WrappedComponent: ComponentType<P>,
): ComponentType<P> {
  const WithPriorityScrollableContentProvider = (
    props: P & React.HTMLAttributes<HTMLElement>,
  ) => (
    <PriorityScrollableContentProvider>
      <WrappedComponent {...props} />
    </PriorityScrollableContentProvider>
  );
  // Optional: Set display name for better debugging
  const wrappedComponentName =
    WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WithPriorityScrollableContentProvider.displayName = `withPriorityScrollableContentProvider(${wrappedComponentName})`;

  return WithPriorityScrollableContentProvider;
}

export default withPriorityScrollableContentProvider;
